import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import ServicesHero from './components/ServicesHero';
import ServicesGrid from './components/ServicesGrid';
import ServicesAlliances from './components/ServicesAlliances';
import ServicesContact from './components/ServicesContact';
import ServicesCTA from './components/ServicesCTA';
import SeoHead from '../../components/SeoHead';

const servicesJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Business Consulting',
    provider: {
      '@type': 'Organization',
      name: 'CJ Solutions Ltd',
      url: `${import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com'}`,
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Limassol',
        addressCountry: 'CY',
      },
    },
    name: 'Compliance, Licensing & Financial Consulting Services',
    description: 'CJ Solutions Ltd provides iGaming & Forex licensing, AML & KYC outsourcing, compliance, tax advisory, accounting, legal drafting, and company formation services in Cyprus.',
    areaServed: {
      '@type': 'Place',
      name: 'Cyprus',
    },
    url: `${import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com'}/services`,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'CJ Solutions Services',
    url: `${import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com'}/services`,
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'iGaming & Forex Licensing',
        url: `${import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com'}/services/igaming-fx-licensing`,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'AML & KYC Outsourcing',
        url: `${import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com'}/services/aml-kyc-outsourcing`,
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: 'Compliance Outsourcing',
        url: `${import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com'}/services/compliance-outsourcing`,
      },
      {
        '@type': 'ListItem',
        position: 4,
        name: 'Tax & Payroll Outsourcing',
        url: `${import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com'}/services/tax-payroll-outsourcing`,
      },
      {
        '@type': 'ListItem',
        position: 5,
        name: 'Accounting Outsourcing',
        url: `${import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com'}/services/accounting-outsourcing`,
      },
      {
        '@type': 'ListItem',
        position: 6,
        name: 'Legal Drafting & AML Policies',
        url: `${import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com'}/services/legal-drafting-outsourcing`,
      },
      {
        '@type': 'ListItem',
        position: 7,
        name: 'Cyprus Company Formation',
        url: `${import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com'}/services/company-formation`,
      },
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: `${import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com'}` },
      { '@type': 'ListItem', position: 2, name: 'Services', item: `${import.meta.env.VITE_SITE_URL || 'https://www.cjsolutionsltd.com'}/services` },
    ],
  },
];

export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-slate-50">
      <SeoHead
        title="iGaming Licensing, AML & Compliance | CJ Solutions"
        description="Explore CJ Solutions Ltd's full range of services: iGaming & Forex licensing, AML & KYC, compliance outsourcing, tax advisory, accounting, legal drafting, and company formation in Cyprus."
        keywords="iGaming licensing Cyprus, Forex license, AML KYC outsourcing, compliance services, tax advisory Cyprus, company formation"
        canonical="/services"
        jsonLd={servicesJsonLd}
      />
      <Header />
      <ServicesHero />
      <div style={{contentVisibility: 'auto', containIntrinsicSize: '0 1200px'}}>
        <ServicesGrid />
      </div>
      <div style={{contentVisibility: 'auto', containIntrinsicSize: '0 400px'}}>
        <ServicesCTA />
      </div>
      <div style={{contentVisibility: 'auto', containIntrinsicSize: '0 400px'}}>
        <ServicesAlliances />
      </div>
      <div style={{contentVisibility: 'auto', containIntrinsicSize: '0 600px'}}>
        <ServicesContact />
      </div>
      <Footer />
    </div>
  );
}
